const nav = {

	init: () => {
		nav.hamburger();
		nav.initScrollListener();
		nav.initToggleSubmenu();
		nav.initToggleSearchbar();
		nav.initDataHrefLinkListener();
	},

	initToggleSearchbar: () => {
		const togglers = document.querySelectorAll(`[data-searchbar-toggle]`);
		togglers.forEach((element) => {
		    element.addEventListener('click', (ev) => {
				ev.preventDefault();
				document.body.classList.toggle('searchbar-active');
			})
		})
	},

	initScrollListener: () => {
		document.addEventListener('scroll', () => {
			document.body.classList.toggle('is-scrolled', window.scrollY > 0);
		});
	},

	hamburger: () => {
		let hamburger = document.querySelector('[data-header-toggle]');
		if (!hamburger)
			return;

		hamburger.addEventListener('click', () => {
			document.body.classList.toggle('header-is-active')
		})
	},
	initToggleSubmenu: () => {
		const arrows = document.querySelectorAll(`[data-toggle-submenu]`);
		arrows.forEach((arrow) => {
		    arrow.addEventListener('click', (ev) => {
				ev.preventDefault();
				const parent = arrow.closest('li');
				const submenu = parent.querySelector('.main-menu__submenu');
				const isActive = parent.classList.contains('submenu-active');
				parent.classList.toggle('submenu-active', !isActive);
				if(isActive){
					submenu.style.height = 0;
				}else{
					submenu.style.height = submenu.scrollHeight+'px';
				}
			});
		})
	},

	initDataHrefLinkListener: () => {
		const links = document.querySelectorAll(`[data-href]`);
		links.forEach((element) => {
		    element.addEventListener('click', (ev) => {
				ev.preventDefault();
				window.location.href = element.dataset.href;
			})
		})
	}
}

export default nav;
